import { computed, Injectable } from '@angular/core';

import { DialogSize, WcgMenuOption } from '@wcg/frontend-framework';

import {
  IrisMapping,
  IrisSettingsDialogComponent,
  IrisSettingsDialogData,
} from '@data-access/configurations';
import { OpenDialogState } from '@data-access/shared';

import { submissionTokenizer } from '../store';

@Injectable()
export class SubmissionFacadeService {
  private readonly _submissionTokenizer = submissionTokenizer();

  private readonly _$irisRoutingGroups = computed(() => {
    const _routingGroups = this._submissionTokenizer.$irisRoutingGroups();
    if (!_routingGroups.length) {
      return [] as WcgMenuOption[];
    }
    return _routingGroups.map((group) => ({
      id: `${group.group_id}`,
      label: group.name,
    })) as WcgMenuOption[];
  });

  private readonly _$canCloseDialog = computed(() =>
    this._submissionTokenizer.$canCloseDialog(),
  );

  openSettingsDialog() {
    const _data: OpenDialogState<IrisSettingsDialogData> = {
      component: () => IrisSettingsDialogComponent,
      componentData: {
        callbacks: {
          save: this.saveSettings.bind(this),
        },
        canCloseDialog: this._$canCloseDialog,
        data: this._submissionTokenizer.$irisMapping,
        dialogSize: DialogSize.SMALL,
        routingGroupOptions: this._$irisRoutingGroups,
      },
      type: 'settings',
    };
    this._submissionTokenizer.openDialog(_data);
  }

  saveSettings(irisMapper: IrisMapping): void {
    this._submissionTokenizer.updateSubmissionTypeIrisMapping({
      ...irisMapper,
    });
  }
}
